const url = process.env.REACT_APP_MY_ENV_API_URL;
const AUTH_URL_PROTOCOL =
    process.env.REACT_APP_PROTOCOL === "localhost" ? "http" : "https";

const Routes = {
    base: url,
    getCarbonData: url + "/carbon-data",
    getInspection: url + "/inspection",
    getInspections: url + "/inspections",
    deleteAsset: url + "/inspection/asset",
    jwtValidation: url?.replace("/api", ""),
    authUrlProtocol: AUTH_URL_PROTOCOL,
    updateInspectionReuseStatus: url + "/inspectionDocReuse",
    updateInspectionReportReuseStatus: url + "/inspectionReportDocReuse",
    assignImagesToDefect: url + "/inspection/defects/assign-images",
};

export default Routes;
